export const THEME_COLORS = {
    "light": {
        tertiary: '134, 134, 134',
        buttonTextColor: '17, 17, 17',
        logo: '255, 50, 114',
        primary: {
            DEFAULT: '228, 37, 117',
            '100': '246, 182, 209',
            '200': '241, 146, 186',
            '300': '237, 110, 163',
            '400': '232, 73, 140',
            '500': '228, 37, 117',
            '600': '166, 51, 94',
            '700': '136, 17, 67',
            '800': '147, 8, 99',
            '900': '196, 153, 175',
            'text': '17, 17, 17',
        },
        secondary: {
            DEFAULT: '240, 240, 240',
            '100': '46, 59, 147',
            '200': '134, 134, 134',
            '300': '139, 139, 139',
            '400': '177, 177, 177',
            '500': '218, 218, 218',
            '600': '223, 223, 223',
            '700': '240, 240, 240',
            '800': '243, 244, 246',
            '900': '250, 248, 248',
            'text': '108, 108, 108',
        },
    },
    "default": {
        tertiary: '118, 128, 147',
        buttonTextColor: '228, 229, 240',
        logo: '255, 50, 114',
        borderRadius: 'default',
        warning: {
            Foreground: '255, 201, 74',
            Background: '47, 43, 29',
        },
        error: {
            Foreground: '255, 97, 97',
            Background: '46, 27, 27',
        },
        success: {
            Foreground: '89, 224, 125',
            Background: '14, 43, 22',
        },
        primary: {
            DEFAULT: '204, 45, 93',
            '100': '255, 148, 176',
            '200': '245, 103, 141',
            '300': '235, 84, 129',
            '400': '229, 64, 114',
            '500': '204, 45, 93',
            '600': '178, 29, 74',
            '700': ' 143, 23, 59',
            '800': '89, 14, 37',
            '900': '46, 7, 19',
            'text': '225, 227, 230',
        },
        secondary: {
            DEFAULT: '17, 29, 54',
            '100': '60, 72, 97',
            '200': '52, 63, 87',
            '300': '40, 50, 71',
            '400': '31, 40, 61',
            '500': '23, 31, 49',
            '600': '18, 25, 41',
            '700': '14, 21, 36',
            '800': '11, 17, 31',
            '900': '7, 12, 23',
            'text': '163, 173, 194',
        },
    },
    "ton": {
        tertiary: '134, 134, 134',
        buttonTextColor: '15, 15, 15',
        logo: '15, 15, 15',
        primary: {
            DEFAULT: '51, 144, 236',
            '100': '246, 182, 209',
            '200': '241, 146, 186',
            '300': '237, 110, 163',
            '400': '232, 73, 140',
            '500': '45, 148, 229',
            '600': '166, 51, 94',
            '700': '136, 17, 67',
            '800': '45, 148, 229',
            '900': '51, 144, 236',
            'text': '15, 15, 15',
        },
        secondary: {
            DEFAULT: '240, 240, 240',
            '100': '199, 201, 206',
            '200': '208, 210, 211',
            '300': '212, 214, 219',
            '400': '220, 222, 226',
            '500': '227, 230, 233',
            '600': '229, 231, 235',
            '700': '241, 243, 245',
            '800': '243, 244, 246',
            '900': '250, 248, 248',
            'text': '106, 119, 133',
        },
    },
    "immutable": {
        tertiary: '182, 182, 182',
        buttonTextColor: '19, 19, 19',
        logo: '187, 187, 187',
        primary: {
            DEFAULT: '243, 243, 243',
            '100': '255, 255, 255',
            '200': '255, 255, 255',
            '300': '255, 255, 255',
            '400': '255, 255, 255',
            '500': '243, 243, 243',
            '600': '215, 215, 215',
            '700': '187, 187, 187',
            '800': '159, 159, 159',
            '900': '131, 131, 131',
            'text': '243, 243, 243',
        },
        secondary: {
            DEFAULT: '37, 37, 37',
            '100': '119, 119, 119',
            '200': '98, 98, 98',
            '300': '78, 78, 78',
            '400': '57, 57, 57',
            '500': '37, 37, 37',
            '600': '13, 13, 13',
            '700': '13, 13, 13',
            '800': '13, 13, 13',
            '900': '0, 0, 0',
            'text': '182, 182, 182',
        },
    },
    "immutablePlay": {
        tertiary: '182, 182, 182',
        buttonTextColor: '19, 19, 19',
        logo: '187, 187, 187',
        header: {
            hideMenu: true,
            hideTabs: true,
            hideWallets: true,
        },
        cardBackgroundStyle: {
            backgroundColor: 'transparent',
        },
        primary: {
            DEFAULT: '243, 243, 243',
            '100': '255, 255, 255',
            '200': '255, 255, 255',
            '300': '255, 255, 255',
            '400': '255, 255, 255',
            '500': '243, 243, 243',
            '600': '215, 215, 215',
            '700': '187, 187, 187',
            '800': '159, 159, 159',
            '900': '131, 131, 131',
            'text': '243, 243, 243',
        },
        secondary: {
            DEFAULT: '37, 37, 37',
            '100': '119, 119, 119',
            '200': '98, 98, 98',
            '300': '78, 78, 78',
            '400': '57, 57, 57',
            '500': '37, 37, 37',
            '600': '13, 13, 13',
            '700': '13, 13, 13',
            '800': '13, 13, 13',
            '900': '0, 0, 0',
            'text': '182, 182, 182',
        },
    }
};
